
export const routeEnum = Object.freeze({
  SIGN_IN: 'Sign in',
  PAYMENT: 'Payment',
  WELCOME: 'Welcome',
});
